define('modules/editor/views/inline_toolbar',['require','exports','module','lib/util','base/itemview','../models/editorstate','../behaviours/toolbar'],function(require, exports, module) {
  "use strict";

  var util = require("lib/util"),
      ItemView = require("base/itemview"),
      EditorState = require("../models/editorstate"),
      ActiveItemState = EditorState.activeItemState;

  /**
   * The element toolbar that performs operation on the selected element
   * It has no template, its HTML it's included in the Page template
     Location: /templates/page.html
     The functionality (Controller) is located in behaviours/toolbar.js
   */
  module.exports = ItemView.extend({
    className: "js-inline-toolbar",
    initialize: function(options) {
      //return this.render();
    },
    removeSectionControls: function() {
      this.$(".js-section-down,.js-section-up").hide();
    },
    removeItemControls: function() {
      this.$(".js-element-down,.js-element-up, .js-edit-content").hide();
    },
    removeDeleteButton: function() {
      this.$(".js-delete").hide();
    },
    removeEditButton: function() {
      this.$(".js-edit").hide();
    },
    removeDuplicateButton: function() {
      this.$(".js-duplicate").hide();
    },
    removeEditContentButton: function(){
      this.$(".js-edit-content").hide();
    },
    resetControls: function(){
      this.$(".js-section-down,.js-section-up").show();
      this.$(".js-element-down,.js-element-up").show();
      this.$(".js-delete").show();
      this.$(".js-edit").show();
      this.$(".js-duplicate").show();
      this.$(".js-edit-content").show();
    },
    hide: function(){
      this.$el.css({
        top: "-1000px",
        left: "-1000px"
      });
    },
    show: function(containerView){
      var selectedModel = ActiveItemState.getActiveItem();
      if(!selectedModel) {
        return;
      }
      if(this.$el.parents(".lpg-page").length === 0){
        return;
      }
      selectedModel = selectedModel.formModel || selectedModel;
      this._setupToolbar(selectedModel);
      var currentPos = selectedModel.name !== "section" ?
        selectedModel.getPosition() : {x:0, y:0};
      var parentCoords = this.$el.parents(".lpg-page").offset();
      var localCoords = {
        left: parseInt(currentPos.x + containerView.$el.offset().left - parentCoords.left),
        top: parseInt(currentPos.y + containerView.$el.offset().top - parentCoords.top)
      };
      this.$el.css(localCoords);

    },
    onRender: function(){
      //first render, hide if nothing selected
      //this.setupToolbar();
      this.$el.i18n();
    },
    _setupToolbar: function(elementModel){
      this.resetControls();
      switch (elementModel.name) {
      case "section":
        this.removeItemControls();
        break;
      case "element:form:button":
        this.removeEditButton();
        this.removeEditContentButton();
        this.removeDeleteButton();
        this.removeItemControls();
        this.removeDuplicateButton();
        this.removeSectionControls();
        break;
      case "element:form":
        this.removeDuplicateButton();
        this.removeSectionControls();
        break;
      case "element:button":
      case "element:area":
        this.removeEditContentButton();
        this.removeSectionControls();
        break;
      case "element:social":
        this.removeEditContentButton();
        this.removeSectionControls();
        break;
      default:
        this.removeSectionControls();
      }
    }
  });

  util.mixin(module.exports, require("../behaviours/toolbar"));

});

